module.exports = __webpack_public_path__ + "static/desktop/img/photobook-3-thumb.4f732022.png";